/**
 * Parsing lead capture page widgets data
 * @param {object} widgets
 * @return {object} widgetsData
 */

const parseWidgetsData = (widgets) => {
    const widgetsData = {}

    widgets?.forEach((widget) => {
        switch (widget.type) {
            case "lead_gen_banner": {
                const { image_dweb, image_mweb } = widget.data
                widgetsData["leadGenBanner"] = {
                    dWeb: {
                        url: image_dweb.url,
                        alt: image_dweb.alt,
                    },
                    mWeb: {
                        url: image_mweb.url,
                        alt: image_mweb.alt,
                    },
                }
                break
            }
            case "lead_gen_instructions": {
                const { image_dweb, image_mweb } = widget.data
                widgetsData["leadGenInstructions"] = {
                    dWeb: {
                        url: image_dweb.url,
                        alt: image_dweb.alt,
                    },
                    mWeb: {
                        url: image_mweb.url,
                        alt: image_mweb.alt,
                    },
                }
                break
            }
            case "lead_gen_form":
                {
                    const { header, icon, form_fields, cta, support_text, background } = widget.data
                    widgetsData["leadGenForm"] = {
                        header,
                        icon,
                        formFields: form_fields,
                        ctaLabel: cta.label,
                        ctaAction: cta.action,
                        supportText: support_text,
                        backgroundDweb: background,
                        backgroundMweb: "linear-gradient(90deg, #ffffff 0%, #ffffff 100%)",
                    }
                }
                break
            default:
                break
        }
    })

    return widgetsData
}

/**
 * Parsing lead capture page dialogs data
 * @param {object} dialogs
 * @return {object} dialogsData
 */
const parseDialogsData = (dialogs) => {
    const dialogsData = {}
    for (const type in dialogs) {
        const data = dialogs[type]
        switch (type) {
            case "submission_success_dialog": {
                const { icon, header, sub_header, cta } = data
                dialogsData["submissionSuccessDialog"] = {
                    icon,
                    header,
                    subHeader: sub_header,
                    cta,
                }
                break
            }
            case "submission_failure_dialog": {
                const { icon, header, sub_header, cta } = data
                dialogsData["submissionFailureDialog"] = {
                    icon,
                    header,
                    subHeader: sub_header,
                    cta,
                }
                break
            }
            default:
                break
        }
    }
    return dialogsData
}

/**
 * Parsing lead capture page data
 * @param {object} data
 * @return {object} pageData
 */
export const parsePageData = (data) => {
    const { widgets, dialogs } = data
    return {
        widgets: parseWidgetsData(widgets),
        dialogs: parseDialogsData(dialogs),
    }
}
